import { forwardRef, createElement } from 'react';

function IconThumbUp(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M14.738 2.403c.287.297.425.704.389 1.117l-.022.155-.85 4.253h5.058c1.868 0 3.145 1.925 2.531 3.719l-.06.163-2.919 7.066a1.811 1.811 0 01-1.495 1.117l-.152.007H9.161c-.935 0-1.709-.754-1.784-1.705l-.006-.152V8.866c0-.438.149-.86.414-1.19l.105-.12 4.96-5.144a1.298 1.298 0 011.888-.01zM3.79 8.857c.936 0 1.71.754 1.785 1.705l.006.152v7.429C5.58 19.164 4.775 20 3.79 20c-.936 0-1.71-.754-1.785-1.705L2 18.143v-7.43c0-1.02.806-1.856 1.79-1.856zm9.749-4.999L8.97 8.598a.373.373 0 00-.092.19l-.007.078v9.277c0 .18.112.318.237.35l.053.007h8.057c.08 0 .166-.047.223-.129l.038-.067 2.916-7.062c.34-.83-.192-1.728-.97-1.808l-.112-.006h-6.888l1.114-5.57z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ThumbUp = /*#__PURE__*/forwardRef(IconThumbUp);

export default ThumbUp;
//# sourceMappingURL=ThumbUp.js.map
